import {combineReducers} from 'redux';
import questions from './store/questions/reducer'

export default combineReducers({
    questions
});
